export const CHECKOUT_CONTEXT_KEY = "sugalumps_checkout_context";
export const DELIVERY_SCHEDULE_KEY = "sugalumps_delivery_schedule";

export function cartItemsForCheckout(items) {
  return (items || []).map((item) => {
    const payload = {
      quantity: item.quantity || 1,
      flavor_ids: Array.isArray(item.flavor_ids) ? item.flavor_ids : [],
      add_on_ids: Array.isArray(item.add_on_ids) ? item.add_on_ids : [],
    };

    if (item.special_id || item.special) {
      payload.special_id = item.special_id || item.special;
    } else {
      payload.variant_id = item.variant_id || item.variant || null;
    }

    return payload;
  });
}

export function saveCheckoutContext(context) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(CHECKOUT_CONTEXT_KEY, JSON.stringify(context));
}

export function readCheckoutContext() {
  if (typeof window === "undefined") return null;
  try {
    const parsed = JSON.parse(window.localStorage.getItem(CHECKOUT_CONTEXT_KEY) || "null");
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function clearCheckoutContext() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(CHECKOUT_CONTEXT_KEY);
  window.localStorage.removeItem(DELIVERY_SCHEDULE_KEY);
}
